module.exports = __webpack_public_path__ + "assets/img/1210.86543583.png";